import { IMeta, IPagination, ISort } from "@delanobgt/admin-core/util/types";
import { produce } from "immer";
import { Reducer } from "redux";
import { ERetailShopSortField, IRetailShop, PRetailShopFilter } from "src/core/retailShop/entities";
import { ActionType, createAction, getType } from "typesafe-actions";

/*
 * state
 */
export interface IRetailShopState {
  retailShops: IRetailShop[];
  loading: boolean;
  error: unknown;
  meta: IMeta;
}

const initialState: IRetailShopState = {
  retailShops: [],
  loading: false,
  error: null,
  meta: {
    limit: 10,
    offset: 0,
    total: 0,
  },
};

/*
 * action types
 */
const FETCH_REQUESTED = "retail-shop/FETCH_REQUESTED";
const FETCH_SUCCEEDED = "retail-shop/FETCH_SUCCEEDED";
const FETCH_FAILED = "retail-shop/FETCH_FAILED";
const POLLING_START_REQUESTED = "retail-shop/POLLING_START_REQUESTED";
const POLLING_STOP_REQUESTED = "retail-shop/POLLING_STOP_REQUESTED";

/*
 * action creators
 */
export const actions = {
  fetchRequested: createAction(FETCH_REQUESTED)(),

  fetchSucceeded: createAction(FETCH_SUCCEEDED)<{
    data: IRetailShop[];
    meta: IMeta;
  }>(),

  fetchFailed: createAction(FETCH_FAILED)<unknown>(),

  pollingStartRequested: createAction(POLLING_START_REQUESTED)<{
    filter: PRetailShopFilter;
    pagination: IPagination;
    sorts: ISort<ERetailShopSortField>[];
    refreshDelay: number;
  }>(),

  pollingStopRequested: createAction(POLLING_STOP_REQUESTED)(),
};
export type TActions = ActionType<typeof actions>;

const reducer: Reducer<IRetailShopState, TActions> = (state = initialState, action) => {
  return produce<IRetailShopState>(state, (draft) => {
    switch (action.type) {
      case getType(actions.fetchRequested): {
        draft.loading = true;
        draft.error = null;
        break;
      }
      case getType(actions.fetchSucceeded): {
        const {
          payload: { data, meta },
        } = action;
        draft.retailShops = data;
        draft.loading = false;
        draft.error = null;
        draft.meta = meta;
        break;
      }
      case getType(actions.fetchFailed): {
        const { payload } = action;
        draft.loading = false;
        draft.error = payload;
        break;
      }
    }
  });
};

export default reducer;
